import React,{Fragment, useState} from 'react';
import SetupBoxImage from '../../../images/img/Bingeandroidtv1.png'
import BoxSelectionComponent from '../../FormFields/BoxSelectionComponent/BoxSelectionComponent'
import FilterConfirmation from '../../FormFields/FilterConfirmationComponent/FilterConfirmation';
const testData = [
    {
        checked: false,
        room:"Room 1",
        boxId: "123s",
        imageUrl: SetupBoxImage,
        boxType:"Primay Box"
        },
        {
            checked: false,
            room:"Room 2",
            boxId: "12ds",
            imageUrl: SetupBoxImage,
            boxType:"Secondary Box same as Main Box"
            },
            {
                checked: false,
                room:"Bedroom",
                boxId: "A2ds",
                imageUrl: SetupBoxImage,
                boxType:"Secondary Box"
            }
]

export default function MessageA60(props) {
    const {text_data, code} = props.item;
const {tag} = props;
// console.log(code,tag,"code,tag in A600");
const [apllied, setApplied] = useState(false);
const handleFilterApplied = (data) => {
  setApplied(data);
};

 
const onClickHandler =(code,data,tag)=>{
    // console.log(code,data,tag,"code,data,tag in A60");
    props.handleClick(code,data,tag);
}
  return (
//    <Fragment>
//         {!apllied ?<BoxSelectionComponent 
//         data ={text_data.boxDetails}
//         onClickHandler={onClickHandler}
//         code={code}
//         tag={tag}
//         filterToggle={(data) => {
//             handleFilterApplied(data);
//           }}
//         /> :<FilterConfirmation 
//         mainText1={"Selected Box"}
//           mainText1Data={["English", "Hindi"]}
//         />}
        
//    </Fragment>
<BoxSelectionComponent 
        data ={text_data.boxDetails}
        onClickHandler={onClickHandler}
        code={code}
        tag={tag}
         
        /> 
)
 }
